import { render, staticRenderFns } from "./resolve-ticket.vue?vue&type=template&id=555145cc&scoped=true&"
import script from "./resolve-ticket.vue?vue&type=script&lang=js&"
export * from "./resolve-ticket.vue?vue&type=script&lang=js&"
import style0 from "./resolve-ticket.vue?vue&type=style&index=0&id=555145cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555145cc",
  null
  
)

export default component.exports